import React, { useState, useEffect, useContext } from "react";
import CommonListHeader from 'components/layout/list/header'
import CommonNavigatorHeader from "components/layout/list/navigation";
import CommonTableContainer from 'components/layout/list/table'
import {useUsTiresListQuery} from "services/ustires";
import { useParams } from "react-router-dom";

const UsTiresMain = () => {
    
    let { filter } = useParams();
    const [page, setPage] = useState(0)
    
    const searchOnChange = (text) => {
        setCriteria({...criteria, searchKeyword: text});
        console.log(criteria);
    }

    const tableTitle = [
        {md: 1, value: 'Dot Range' },
        {md: 2, value: 'Manufacturer Name' },
        {md: 3, value: 'Brand' },
        {md: 4, value: 'Model' },
        {md: 5, value: 'Size'  },
        {md: 6, value: 'Date' }
    ]

    const [criteria, setCriteria] = useState({
        filter: filter,
        page: page,
        sort: 'size.keyword',
        order: 'desc',
        searchKeyword: '',
    });

    const {activeList, activeCount, activeStatus, activeLoading, fetching} = useUsTiresListQuery({criteria: criteria}, 
        {
          selectFromResult: ({ data, status, isLoading, isFetching }) => ({
            activeList: data?.hits?.hits?.map(d=>{
                return {
                    ...d._source,
                    id: d._id
                }
            }) || [],
            activeCount: data?.hits?.total?.value || 0,
            activeStatus: status,
            activeLoading: isLoading,
            fetching: isFetching
          })
        }
    );

    return (
        <React.Fragment>
            <CommonListHeader value = {{title: "UsTires Management", description: "Recalls From 2000-23 ustires.org"}} />
            <CommonNavigatorHeader value = {{
                total: activeCount, 
                search: {
                    label: '', 
                    placeHolder: ''
                },
                setPage: setPage,
                page: page,
                setCriteria: setCriteria,
                criteria: criteria
            }} />
            <CommonTableContainer 
                value = {{
                    tableTitle: tableTitle,
                    sort: '',
                    loadRow: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
                    loadColumn: [0, 1, 2, 3, 4, 5],
                    activeList: activeList,
                    type: 'ustires',
                    fulfilled: activeStatus
                }}
            />
        </React.Fragment>
    );
}

export default UsTiresMain;